import { render, staticRenderFns } from "./RoamingForm.vue?vue&type=template&id=6e126f7b&scoped=true"
import script from "./RoamingForm.vue?vue&type=script&lang=js"
export * from "./RoamingForm.vue?vue&type=script&lang=js"
import style0 from "./RoamingForm.vue?vue&type=style&index=0&id=6e126f7b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e126f7b",
  null
  
)

export default component.exports